// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  border-radius: 30px;
}

ion-content {
  --background: hsla(240, 33%, 97%, 1);
  --padding-start: 1rem;
  --padding-end: 0.75rem;
}

.custom-back-button {
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  --padding-bottom: 0;
  margin: 0 5px;
  height: auto;
  width: auto;
}

.custom-chevron-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  margin-left: -10px;
  margin-right: -15px;
  height: 40px;
  border-radius: 5px;
  background-color: hsl(240, 33%, 97%);
}
.custom-chevron-icon ion-icon {
  font-size: 24px;
  color: #000000;
  --ionicon-stroke-width: 48px;
}

@media (max-width: 991px) {
  .button-responsive-margin-ios {
    margin-right: 0px;
  }
  .icon-responsive-margin-ios {
    margin-left: -4px;
    margin-right: -4px;
  }
}
.search-content {
  --ion-background-color: hsla(240, 33%, 97%, 1) !important;
}

.white-toolbar {
  --background: hsla(240, 33%, 97%, 1) !important;
}

ion-toolbar {
  --background: hsla(240, 33%, 97%, 1) !important;
  --border-style: none;
}
ion-toolbar ion-searchbar {
  --box-shadow: none;
  --border-radius: 1.75rem;
  --background: hsla(240, 33%, 97%, 1);
  padding-inline-start: 0.5rem;
  padding-inline-end: 1rem;
}
ion-toolbar ion-searchbar::ng-deep .searchbar-input {
  border-radius: 1.75rem !important;
}
ion-toolbar ion-searchbar::ng-deep .searchbar-clear-icon {
  width: 20px !important;
  height: 20px !important;
  right: 30px !important;
}
ion-toolbar ion-searchbar::ng-deep .searchbar-clear-icon::before {
  transform: translateX(-10px) !important;
  font-size: 18px !important;
  position: relative !important;
}
ion-toolbar ion-searchbar.mobile {
  --border-radius: 0.75rem;
}
ion-toolbar ion-searchbar.mobile::ng-deep .searchbar-input {
  border-radius: 0.75rem !important;
}
ion-toolbar ion-button {
  text-transform: none;
}

ion-content {
  --background: hsla(240, 33%, 97%, 1);
}
ion-content .search-section {
  margin-bottom: 1.5rem;
}
ion-content .search-section h5 {
  font-weight: 600;
  color: var(--ion-color-dark);
  margin: 0 0 0.5rem;
}
ion-content .search-section .tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1rem;
}
ion-content .search-section .tags ion-button {
  --border-radius: 1rem;
  text-transform: none;
  font-size: 1rem;
  height: 2rem !important;
  margin: 0;
  --padding-start: 12px;
  --padding-end: 12px;
}

.search-overlay-desktop {
  position: fixed !important;
  top: 10px !important;
  left: 10px !important;
  margin: 0 !important;
  transform: none !important;
  --width: 100%;
  --height: 100%;
  --max-width: 100%;
  --max-height: 100%;
  --border-radius: 0;
  --box-shadow: none;
}
.search-overlay-desktop .modal-wrapper {
  position: fixed !important;
  top: 10px !important;
  left: 10px !important;
  transform: none !important;
  margin: 0 !important;
}
.search-overlay-desktop app-search-overlay {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.search-overlay-desktop app-search-overlay ion-header {
  flex-shrink: 0;
}
.search-overlay-desktop app-search-overlay ion-content {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.game-list {
  background-color: hsl(240, 33%, 97%);
  padding-top: 0;
}
.game-list .game-item {
  --background: var(--ion-color-light);
  --padding-start: 0.5rem;
  --padding-end: 0.5rem;
  --padding-top: 0.5rem;
  --padding-bottom: 0.5rem;
}
.game-list .game-item:not(:last-of-type) {
  margin-bottom: 2px;
}
.game-list .game-item ion-thumbnail {
  width: 3rem;
  height: 3rem;
  margin: 0 1rem 0 0;
}
.game-list .game-item ion-thumbnail img {
  border-radius: 0.25rem;
}
.game-list .game-item ion-label h2 {
  font-size: 1em;
  font-weight: bold;
}
.game-list .game-item ion-label p {
  font-size: 0.8em;
  color: var(--ion-color-medium-shade);
}

.highlight-text {
  background-color: transparent;
  color: var(--ion-color-primary);
  font-weight: bold;
}

@media (min-width: 992px) {
  ion-toolbar ion-buttons[slot=end] {
    display: none;
  }
  .search-overlay-desktop {
    position: fixed !important;
    top: 10px !important;
    left: 10px !important;
    --width: 400px;
    --height: auto;
    --max-width: 400px;
    --max-height: calc(100vh - 100px);
    --border-radius: 8px;
    --box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    --align-items: initial;
    --justify-content: initial;
    --inset: auto;
  }
  .search-overlay-desktop .modal-wrapper {
    position: fixed !important;
    top: 10px !important;
    left: 10px !important;
    width: var(--width);
    height: var(--height);
    max-width: var(--max-width);
    max-height: var(--max-height);
    transform: none !important;
    margin: 0 !important;
    display: block !important;
    overflow: hidden;
  }
}
@media (max-width: 991px) {
  :host {
    background-color: hsl(240, 33%, 97%);
    padding-top: 10px !important;
    width: 100%;
    max-width: 100%;
    border-radius: 0;
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
  }
  ion-toolbar {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  ion-content .search-section {
    margin: 1rem 0 !important;
  }
  ion-content .search-section h5 {
    font-size: 1rem !important;
  }
  .game-list .game-item ion-thumbnail {
    width: 50px;
    height: 50px;
  }
}
.search__favicon {
  font-size: 22px;
  cursor: pointer;
}

ion-icon[name*=heart] {
  fill: var(--fav-icon-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/search/search.component.scss"],"names":[],"mappings":"AAGA;EACE,mBAAA;AAFF;;AAKA;EACE,oCAAA;EACA,qBAAA;EACA,sBAAA;AAFF;;AAMA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;AAHF;AAKE;EACE,eAAA;EACA,cAAA;EACA,4BAAA;AAHJ;;AAOA;EACE;IACE,iBAAA;EAJF;EAOA;IACE,iBAAA;IACA,kBAAA;EALF;AACF;AAQA;EACE,yDAAA;AANF;;AASA;EACE,+CAAA;AANF;;AASA;EACE,+CAAA;EACA,oBAAA;AANF;AAQE;EACE,kBAAA;EACA,wBAAA;EACA,oCAAA;EACA,4BAAA;EACA,wBAAA;AANJ;AASM;EACE,iCAAA;AAPR;AAWM;EACE,sBAAA;EACA,uBAAA;EACA,sBAAA;AATR;AAWQ;EACE,uCAAA;EACA,0BAAA;EACA,6BAAA;AATV;AAcI;EACE,wBAAA;AAZN;AAeQ;EACE,iCAAA;AAbV;AAmBE;EACE,oBAAA;AAjBJ;;AAqBA;EACE,oCAAA;AAlBF;AAoBE;EACE,qBAAA;AAlBJ;AAoBI;EACE,gBAAA;EACA,4BAAA;EACA,kBAAA;AAlBN;AAqBI;EACE,aAAA;EACA,eAAA;EACA,iBAAA;AAnBN;AAqBM;EACE,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,qBAAA;EACA,mBAAA;AAnBR;;AA0BA;EAEE,0BAAA;EACA,oBAAA;EACA,qBAAA;EACA,oBAAA;EACA,0BAAA;EAGA,aAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AA1BF;AA6BE;EAEE,0BAAA;EACA,oBAAA;EACA,qBAAA;EAGA,0BAAA;EACA,oBAAA;AA9BJ;AAkCE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AAhCJ;AAkCI;EACE,cAAA;AAhCN;AAmCI;EACE,OAAA;EACA,gBAAA;EACA,aAAA;AAjCN;;AAsCA;EACE,oCAAA;EACA,cAAA;AAnCF;AAsCE;EACE,oCAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,wBAAA;AApCJ;AAsCI;EACE,kBAAA;AApCN;AAuCI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AArCN;AAuCM;EACE,sBAAA;AArCR;AA0CM;EACE,cAAA;EACA,iBAAA;AAxCR;AA2CM;EACE,gBAAA;EACA,oCAAA;AAzCR;;AAgDA;EACE,6BAAA;EACA,+BAAA;EACA,iBAAA;AA7CF;;AAiDA;EAII;IACE,aAAA;EAjDJ;EAsDA;IAEE,0BAAA;IACA,oBAAA;IACA,qBAAA;IAGA,cAAA;IACA,cAAA;IACA,kBAAA;IACA,iCAAA;IACA,oBAAA;IACA,4CAAA;IAGA,sBAAA;IACA,0BAAA;IACA,aAAA;EAzDF;EA4DE;IACE,0BAAA;IACA,oBAAA;IACA,qBAAA;IAIA,mBAAA;IACA,qBAAA;IACA,2BAAA;IACA,6BAAA;IAGA,0BAAA;IACA,oBAAA;IAGA,yBAAA;IACA,gBAAA;EAjEJ;AACF;AAsEA;EACE;IACE,oCAAA;IACA,4BAAA;IACA,WAAA;IACA,eAAA;IACA,gBAAA;IACA,uCAAA;IACA,yCAAA;EApEF;EAuEA;IACE,0BAAA;IACA,2BAAA;EArEF;EAyEE;IACE,yBAAA;EAvEJ;EAyEI;IACE,0BAAA;EAvEN;EA8EI;IACE,WAAA;IACA,YAAA;EA5EN;AACF;AAkFA;EACE,eAAA;EACA,eAAA;AAhFF;;AAkFA;EACE,sCAAA;AA/EF","sourcesContent":["// Styles for the search overlay\n\n// Position the overlay at fixed position instead of hiding it\n:host {\n  border-radius: 30px;\n}\n\nion-content {\n  --background: hsla(240, 33%, 97%, 1); // White background for content area\n  --padding-start: 1rem;\n  --padding-end: 0.75rem;\n}\n\n// Custom back button styling\n.custom-back-button {\n  --padding-start: 0;\n  --padding-end: 0;\n  --padding-top: 0;\n  --padding-bottom: 0;\n  margin: 0 5px;\n  height: auto;\n  width: auto;\n}\n\n.custom-chevron-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  margin-left: -10px;\n  margin-right: -15px;\n  height: 40px;\n  border-radius: 5px; // Slightly rounded corners\n  background-color: hsla(240, 33%, 97%, 1); // White background\n\n  ion-icon {\n    font-size: 24px;\n    color: #000000; // Black chevron\n    --ionicon-stroke-width: 48px; // Make the icon a bit more visible/bold\n  }\n}\n\n@media (max-width: 991px) {\n  .button-responsive-margin-ios {\n    margin-right: 0px;\n  }\n\n  .icon-responsive-margin-ios {\n    margin-left: -4px;\n    margin-right: -4px;\n  }\n}\n\n.search-content {\n  --ion-background-color: hsla(240, 33%, 97%, 1) !important; //White background for the items (ion-item default bgr)\n}\n\n.white-toolbar {\n  --background: hsla(240, 33%, 97%, 1) !important; // White background for the toolbar\n}\n\nion-toolbar {\n  --background: hsla(240, 33%, 97%, 1) !important; // Force white background for all toolbars in this component\n  --border-style: none;\n\n  ion-searchbar {\n    --box-shadow: none;\n    --border-radius: 1.75rem;\n    --background: hsla(240, 33%, 97%, 1);\n    padding-inline-start: 0.5rem; // Adjust padding as needed\n    padding-inline-end: 1rem;\n\n    &::ng-deep {\n      .searchbar-input {\n        border-radius: 1.75rem !important;\n      }\n\n      // Since the clear icon uses ::before in shadow DOM\n      .searchbar-clear-icon {\n        width: 20px !important;\n        height: 20px !important;\n        right: 30px !important;\n\n        &::before {\n          transform: translateX(-10px) !important;\n          font-size: 18px !important;\n          position: relative !important;\n        }\n      }\n    }\n\n    &.mobile {\n      --border-radius: 0.75rem;\n\n      &::ng-deep {\n        .searchbar-input {\n          border-radius: 0.75rem !important;\n        }\n      }\n    }\n  }\n\n  ion-button {\n    text-transform: none; // Keep \"Cancel\" text as is\n  }\n}\n\nion-content {\n  --background: hsla(240, 33%, 97%, 1); // White background for content area\n\n  .search-section {\n    margin-bottom: 1.5rem;\n\n    h5 {\n      font-weight: 600;\n      color: var(--ion-color-dark);\n      margin: 0 0 0.5rem;\n    }\n\n    .tags {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 0.75rem 1rem; // Spacing between tags\n\n      ion-button {\n        --border-radius: 1rem; // Rounded corners for tags\n        text-transform: none;\n        font-size: 1rem;\n        height: 2rem !important; // Adjust height as needed\n        margin: 0; // Remove default margins\n        --padding-start: 12px;\n        --padding-end: 12px;\n      }\n    }\n  }\n}\n\n// Default (mobile-first) styling for the modal when search-overlay-desktop class is present\n.search-overlay-desktop {\n  // Position the entire modal at top-left corner\n  position: fixed !important;\n  top: 10px !important;\n  left: 10px !important;\n  margin: 0 !important;\n  transform: none !important;\n\n  // These are Ionic's CSS variables for modals. Ensure they default to fullscreen-like behavior.\n  --width: 100%;\n  --height: 100%;\n  --max-width: 100%;\n  --max-height: 100%;\n  --border-radius: 0; // Or a small value if preferred for mobile modals, e.g., var(--ion-border-radius-md, 8px) if it should match a theme\n  --box-shadow: none; // Typically no shadow for fullscreen mobile modals\n\n  // Ensure .modal-wrapper also behaves for fullscreen initially\n  .modal-wrapper {\n    // Position fixed with important to override any other positioning\n    position: fixed !important;\n    top: 10px !important;\n    left: 10px !important;\n\n    // Override any transforms/margins Ionic might use for centering\n    transform: none !important;\n    margin: 0 !important;\n  }\n\n  // Default layout for app-search-overlay (mobile)\n  app-search-overlay {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n\n    ion-header {\n      flex-shrink: 0;\n    }\n\n    ion-content {\n      flex: 1;\n      overflow-y: auto;\n      min-height: 0;\n    }\n  }\n}\n\n.game-list {\n  background-color: hsla(240, 33%, 97%, 1);\n  padding-top: 0;\n\n  // Styles for the filtered game list (inside the desktop media query or globally if needed)\n  .game-item {\n    --background: var(--ion-color-light);\n    --padding-start: 0.5rem;\n    --padding-end: 0.5rem;\n    --padding-top: 0.5rem;\n    --padding-bottom: 0.5rem;\n\n    &:not(:last-of-type) {\n      margin-bottom: 2px;\n    }\n\n    ion-thumbnail {\n      width: 3rem;\n      height: 3rem;\n      margin: 0 1rem 0 0;\n\n      img {\n        border-radius: 0.25rem; // Slightly rounded corners for game images\n      }\n    }\n\n    ion-label {\n      h2 {\n        font-size: 1em;\n        font-weight: bold;\n      }\n\n      p {\n        font-size: 0.8em;\n        color: var(--ion-color-medium-shade);\n      }\n    }\n  }\n}\n\n// Highlight text in search results\n.highlight-text {\n  background-color: transparent;\n  color: var(--ion-color-primary);\n  font-weight: bold;\n}\n\n// Desktop specific overrides\n@media (min-width: 992px) {\n\n  // Hide cancel button on desktop\n  ion-toolbar {\n    ion-buttons[slot=\"end\"] {\n      display: none;\n    }\n  }\n\n  // Target the ion-modal element itself using the class\n  .search-overlay-desktop {\n    // Keep fixed position from above\n    position: fixed !important;\n    top: 10px !important;\n    left: 10px !important;\n\n    // Override Ionic CSS variables for desired desktop size and appearance\n    --width: 400px;\n    --height: auto; // Let content determine height up to max-height\n    --max-width: 400px;\n    --max-height: calc(100vh - 100px); // Example: max height is viewport height minus 100px\n    --border-radius: 8px;\n    --box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n\n    // Crucially, prevent Ionic from centering the modal using variables\n    --align-items: initial;\n    --justify-content: initial;\n    --inset: auto; // Reset inset used for centering\n\n    // Target the inner modal-wrapper for the actual positioning\n    .modal-wrapper {\n      position: fixed !important; // Use fixed positioning\n      top: 10px !important; // Your desired top position\n      left: 10px !important; // Your desired left position\n\n      // Ensure width/height respect the CSS variables set on the host (ion-modal)\n      // These might not be strictly necessary if vars are respected, but can help enforce\n      width: var(--width);\n      height: var(--height);\n      max-width: var(--max-width);\n      max-height: var(--max-height);\n\n      // Important: Override any transforms/margins Ionic might use for centering\n      transform: none !important;\n      margin: 0 !important;\n\n      // Ensure proper display and overflow\n      display: block !important; // Ensure it behaves as a block for positioning\n      overflow: hidden; // Contained overflow\n    }\n  }\n}\n\n// Mobile-specific styles\n@media (max-width: 991px) {\n  :host {\n    background-color: hsla(240, 33%, 97%, 1);\n    padding-top: 10px !important;\n    width: 100%; // Full width on mobile\n    max-width: 100%;\n    border-radius: 0;\n    padding-left: env(safe-area-inset-left);\n    padding-right: env(safe-area-inset-right);\n  }\n\n  ion-toolbar {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  ion-content {\n    .search-section {\n      margin: 1rem 0 !important;\n\n      h5 {\n        font-size: 1rem !important;\n      }\n    }\n  }\n\n  .game-list {\n    .game-item {\n      ion-thumbnail {\n        width: 50px;\n        height: 50px;\n      }\n    }\n  }\n\n}\n\n.search__favicon {\n  font-size: 22px;\n  cursor: pointer;\n}\nion-icon[name*=\"heart\"] {\n  fill: var(--fav-icon-color) !important; \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
